var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aliyun-player',{ref:"video",staticClass:"video",attrs:{"preload":true,"autoplay":true,"source":_vm.sourceUrl,"cover":_vm.coverUrl,"skinLayout":_vm.skinLayout,"height":_vm.videoHeight,"video-height":_vm.videoHeight},on:{"canplaythrough":_vm.canplaythroughimp,"pause":_vm.pause,"play":_vm.play,"ended":_vm.ended}})
}
var staticRenderFns = []

export { render, staticRenderFns }